(function() {
    'use strict';

    angular
        .module('portalApp')
        .directive('hasApplicationFeature', hasApplicationFeature);

    hasApplicationFeature.$inject = ['VerifyApplicationFeature', 'Principal'];

    function hasApplicationFeature(VerifyApplicationFeature, Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var applicationFeature = attrs.hasApplicationFeature.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function () {

                    VerifyApplicationFeature.verify({applicationFeature:applicationFeature}).$promise
                        .then(function (result) {
                            if (result.data == true) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        })
                        .catch(function () {
                            setHidden();
                            // alert(result || 'Request failed');
                        });
                };

            if (applicationFeature.length > 0) {
                setHidden();

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility();
                });
            }
        }
    }
})();
